import { studioLocalDateTimeToIso } from './studioTime';

export function movableAppointment(a) {
  return Boolean(a?.id && ['scheduled', 'confirmed'].includes(a.status)
    && !a.rescheduled_to && !['processing', 'completed'].includes(a.checkout_status));
}

export function appointmentDuration(a) {
  return Number(a.duration_minutes) || Math.round((new Date(a.end) - new Date(a.start)) / 60000);
}

// Month cells choose a civil day, preserving the Studio's local appointment time
// even when the destination falls on the other side of a DST transition.
export function targetDay(day, appointment, timeZone) {
  try {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en', {
      timeZone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date(appointment.start)).map(p => [p.type, p.value]));
    return studioLocalDateTimeToIso(`${day}T${parts.hour}:${parts.minute}`, timeZone);
  } catch { return null; }
}

export function movePreference(key) {
  try { return Boolean(key && window.localStorage.getItem(key) === 'true'); }
  catch { return false; }
}

export function targetStart(day, offsetY, height, duration, timeZone, startMinute = 600, endMinute = 1140) {
  if (!day || height <= 0 || offsetY < 0 || offsetY > height) return null;
  const minutes = startMinute + Math.round(offsetY / height * (endMinute - startMinute) / 30) * 30;
  if (minutes < startMinute || minutes + duration > endMinute) return null;
  try {
    return studioLocalDateTimeToIso(`${day}T${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`, timeZone);
  } catch { return null; }
}

export function movePayload(a, start) {
  const duration = appointmentDuration(a);
  if (!movableAppointment(a) || !Number.isFinite(duration) || duration < 30 || duration > 600 || duration % 30) throw new Error('Appuntamento non spostabile.');
  if (!start || new Date(start) <= new Date()) throw new Error('Scegli un giorno e un orario futuri.');
  return { title: a.title || '', customer_id: a.customer_id || '', artist_id: a.artist_id || '',
    room_id: a.room_id || '', project_id: a.project_id || '', appointment_type: a.appointment_type || 'tattoo',
    service_type: a.service_type || a.appointment_type || 'tattoo', notes: a.notes || '', status: a.status,
    deposit: Number(a.deposit) || 0, duration_minutes: duration, start,
    end: new Date(new Date(start).getTime() + duration * 60000).toISOString(),
    smart_move: true, expected_start: a.start, expected_updated_at: a.updated_at ?? null };
}

// All geometry is in viewport pixels, as used by elementFromPoint and the body portal.
export function movePreview(gesture, rect, viewportWidth, viewportHeight) {
  const {x,y,grabOffset,appointment,start,kind}=gesture;
  const width=Math.min(208,Math.max(0,viewportWidth-16)), height=64;
  const left=kind==='touch'?x-width/2:(x+12+width<=viewportWidth-8?x+12:x-width-12);
  const top=kind==='touch'?y-height-16:y+12;
  const caption={width,left:Math.max(8,Math.min(left,viewportWidth-width-8)),top:Math.max(8,Math.min(top,viewportHeight-height-8))};
  if(!start||!rect)return {caption,target:null};
  const span=(gesture.gridEnd ?? 1140)-(gesture.gridStart ?? 600);
  const snap=Math.round((y-rect.top-grabOffset)/rect.height*span/30)*30;
  return {caption,target:{left:rect.left+2,top:rect.top+snap/span*rect.height,width:Math.max(0,rect.width-4),height:appointmentDuration(appointment)/span*rect.height}};
}
